var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36428 14.3821C11.3186 14.3821 14.5243 11.1765 14.5243 7.22213C14.5243 3.26777 11.3186 0.0621338 7.36428 0.0621338C4.08933 0.0621338 1.32793 2.26086 0.475708 5.26266L2.59332 5.06213L8.1307 7.75088C8.24071 7.80386 8.3599 7.84856 8.48519 7.88498C8.66549 7.93631 8.85802 7.96942 9.05971 7.98266L12.2043 8.20617L8.80912 9.88829L2.66361 9.01743C2.12882 8.94293 1.56652 9.01246 1.13564 9.20617L0.562849 9.46578C1.50425 12.3212 4.19358 14.3821 7.36428 14.3821Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.4519d83c768281e435332264fa8ddaa9.svg";
export { ForwardRef as ReactComponent };